import { createReducer } from 'app-webtech-core/reducers/createReducer';
import { userAccountRegisterWithEmailRequestReducer } from './registerWithEmail';
import {
  userAccountLogoutFailureReducer,
  userAccountLogoutRequestReducer,
  userAccountLogoutSuccessReducer,
} from './logout';
import {
  LOGIN_WITH_EMAIL,
  LOGIN_WITH_FACEBOOK_TOKEN,
  LOGIN_WITH_GOOGLE_TOKEN,
  LOGIN_WITH_TOKEN,
  LOGIN_WITH_TWITTER_TOKEN,
  LOGOUT,
  REGISTER_WITH_EMAIL,
  REQUEST_PASSWORD_RECOVERY,
  RESET_PASSWORD_WITH_TOKEN,
  CHANGE_PASSWORD_WITH_TOKEN,
  UPDATE_EMAIL_WITH_TOKEN,
} from '../actions/types';
import { USER_ACCOUNT_STATE_STATUSES } from '../constants';
import {
  userAccountRequestPasswordRecoveryFailureReducer,
  userAccountRequestPasswordRecoveryRequestReducer,
  userAccountRequestPasswordRecoverySuccessReducer,
} from './requestPasswordRecovery';
import {
  userAccountResetPasswordWithTokenFailureReducer,
  userAccountResetPasswordWithTokenRequestReducer,
  userAccountResetPasswordWithTokenSuccessReducer,
} from './resetPasswordWithToken';
import {
  userAccountLoginFailureReducer,
  userAccountLoginRequestReducer,
  userAccountLoginSuccessReducer,
} from './login';
import {
  userAccountChangePasswordStoredTokenFailureReducer,
  userAccountChangePasswordStoredTokenRequestReducer,
  userAccountChangePasswordStoredTokenSuccessReducer,
} from './changePasswordStoredToken';
import {
  userAccountUpdateEmailStoredTokenRequestReducer,
  userAccountUpdateEmailStoredTokenFailureReducer,
  userAccountUpdateEmailStoredTokenSuccessReducer,
} from './updateEmailStoredToken';

export const defaultState = {
  accessToken: null,
  data: null,
  error: null,
  firstVisitedAt: Date.now(),
  status: USER_ACCOUNT_STATE_STATUSES.NOT_AUTHENTICATED,
};

export const userAccountReducer = createReducer(defaultState, {
  [REGISTER_WITH_EMAIL.REQUEST]: userAccountRegisterWithEmailRequestReducer,
  [REGISTER_WITH_EMAIL.FAILURE]: userAccountLoginFailureReducer,
  [REGISTER_WITH_EMAIL.SUCCESS]: userAccountLoginSuccessReducer,

  [LOGIN_WITH_EMAIL.REQUEST]: userAccountLoginRequestReducer,
  [LOGIN_WITH_EMAIL.FAILURE]: userAccountLoginFailureReducer,
  [LOGIN_WITH_EMAIL.SUCCESS]: userAccountLoginSuccessReducer,

  [LOGIN_WITH_FACEBOOK_TOKEN.REQUEST]: userAccountLoginRequestReducer,
  [LOGIN_WITH_FACEBOOK_TOKEN.FAILURE]: userAccountLoginFailureReducer,
  [LOGIN_WITH_FACEBOOK_TOKEN.SUCCESS]: userAccountLoginSuccessReducer,

  [LOGIN_WITH_GOOGLE_TOKEN.REQUEST]: userAccountLoginRequestReducer,
  [LOGIN_WITH_GOOGLE_TOKEN.FAILURE]: userAccountLoginFailureReducer,
  [LOGIN_WITH_GOOGLE_TOKEN.SUCCESS]: userAccountLoginSuccessReducer,

  [LOGIN_WITH_TOKEN.REQUEST]: userAccountLoginRequestReducer,
  [LOGIN_WITH_TOKEN.FAILURE]: userAccountLoginFailureReducer,
  [LOGIN_WITH_TOKEN.SUCCESS]: userAccountLoginSuccessReducer,

  [LOGIN_WITH_TWITTER_TOKEN.REQUEST]: userAccountLoginRequestReducer,
  [LOGIN_WITH_TWITTER_TOKEN.FAILURE]: userAccountLoginFailureReducer,
  [LOGIN_WITH_TWITTER_TOKEN.SUCCESS]: userAccountLoginSuccessReducer,

  [LOGOUT.REQUEST]: userAccountLogoutRequestReducer,
  [LOGOUT.FAILURE]: userAccountLogoutFailureReducer,
  [LOGOUT.SUCCESS]: userAccountLogoutSuccessReducer,

  [REQUEST_PASSWORD_RECOVERY.REQUEST]: userAccountRequestPasswordRecoveryRequestReducer,
  [REQUEST_PASSWORD_RECOVERY.FAILURE]: userAccountRequestPasswordRecoveryFailureReducer,
  [REQUEST_PASSWORD_RECOVERY.SUCCESS]: userAccountRequestPasswordRecoverySuccessReducer,

  [RESET_PASSWORD_WITH_TOKEN.REQUEST]: userAccountResetPasswordWithTokenRequestReducer,
  [RESET_PASSWORD_WITH_TOKEN.FAILURE]: userAccountResetPasswordWithTokenFailureReducer,
  [RESET_PASSWORD_WITH_TOKEN.SUCCESS]: userAccountResetPasswordWithTokenSuccessReducer,

  [CHANGE_PASSWORD_WITH_TOKEN.REQUEST]: userAccountChangePasswordStoredTokenRequestReducer,
  [CHANGE_PASSWORD_WITH_TOKEN.FAILURE]: userAccountChangePasswordStoredTokenFailureReducer,
  [CHANGE_PASSWORD_WITH_TOKEN.SUCCESS]: userAccountChangePasswordStoredTokenSuccessReducer,

  [UPDATE_EMAIL_WITH_TOKEN.REQUEST]: userAccountUpdateEmailStoredTokenRequestReducer,
  [UPDATE_EMAIL_WITH_TOKEN.FAILURE]: userAccountUpdateEmailStoredTokenFailureReducer,
  [UPDATE_EMAIL_WITH_TOKEN.SUCCESS]: userAccountUpdateEmailStoredTokenSuccessReducer,
});
